// extracted by mini-css-extract-plugin
export default {"Container":"FeedbackButton_Container__raRTf","Wrapper":"FeedbackButton_Wrapper__XCs3j","FloatText":"FeedbackButton_FloatText__Uof02","Icon":"FeedbackButton_Icon__RF0Az"};